<template>
  <div class="help-box">
    <Header />

    <div class="help-nav">
      <div class="help-title" @click="router.push('/help')">{{ $t(`help.help1`) }}</div>
      <div class="help-search">
        <a-input-search
          @search="onSearch"
          v-model:value="searchValue"
          :placeholder="$t(`tips.tip53`)"
        />
      </div>
      <div class="help-content">
        <div class="content-title">
          <span>{{ $t(`help.help5`) }}</span>
          <span class="title-about" v-if="language == 'zh'"
            >与“<span style="color: #003591">{{ searchValue }}</span
            >”相关的共<span style="color: #003591">{{ objData.count }}</span
            >条</span
          >
          <span class="title-about" v-else
            >There are
            <span style="color: #003591">{{ objData.count }}</span> articles
            related to “<span style="color: #003591">{{ searchValue }}</span
            >”</span
          >
        </div>
        <div class="search-nav">
          <div
            class="search-item"
            v-for="(item, index) in objData.list"
            :key="index"
            @click="hanldeDetail(item)"
          >
            <div class="search-item-title" v-html="item.title"></div>
            <div class="search-item-text" v-html="item.introduction"></div>
            <div class="search-item-time">
              更新时间：{{ formatDate(item.create_time) }}
            </div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <a-pagination
          v-model:current="queryForm.page"
          v-model:pageSize="queryForm.size"
          :total="objData.count"
          :size="screenWidth > 992 ? '' : 'small'"
          :show-total="
            screenWidth > 992
              ? language == 'zh'
                ? (total) => `共有 ${total}条数据`
                : (total) => `There are ${total} data in total`
              : (total) => ''
          "
          @change="getSearchList()"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Header from "./components/Header.vue";
import { formatDate } from "../../utils/formatTime";
import { useRouter, useRoute } from "vue-router";
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onBeforeMount,
  onMounted,
} from "vue";
export default defineComponent({
  components: {
    Header,
  },
  setup() {
    const { proxy } = getCurrentInstance();
    let globalProperties =
      getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axioshanma;
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      searchValue: "",
      language: proxy.$i18n.locale,
      queryForm: {
        page: 1,
        size: 10,
        title: '',
        appid: "51129880-3b54-11ea-aa7a-506b4bfdb014",
      },
      screenWidth: 1920,
      objData: {
        list: [],
        count: 0,
      },
    });
    onBeforeMount(() => {
      state.screenWidth = document.body.clientWidth;
    });
    onMounted(() => {
      console.log(state.language)
      state.searchValue = route.query.searchValue;
      getSearchList();
    });

    const getSearchList = () => {
      state.queryForm.title = state.searchValue;
      axios("/api/ayuda.article/searchArticleList", state.queryForm).then((res) => {
        state.objData = res;
        var reg = new RegExp("(" + state.searchValue + ")", "g");
        state.objData.list.map((item) => {
          item.title = item.title.replace(
            reg,
            "<font color=#003591>" + state.searchValue + "</font>"
          );
          item.introduction = item.introduction
            ? item.introduction.replace(
                reg,
                "<font color=#003591>" + state.searchValue + "</font>"
              )
            : "";
        });
      });
    };

    const handleClick = (value) => {
      router.push({
        path: "/helpCatalog",
        query: {
          id: value.id,
        },
      });
    };

    const onSearch = () => {
      getSearchList();
    };
    const hanldeDetail = (val) => {
      router.push({
        path: "/helpDetail",
        query: {
          id: val.a_id,
        },
      });
    };

    return {
      router,
      ...toRefs(state),
      handleClick,
      onSearch,
      formatDate,
      hanldeDetail,
      getSearchList,
    };
  },
});
</script>
<style scoped>
.help-box {
  background: #f3f6fa;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
}
.help-nav {
  width: 100%;
  margin-top: 88px;
  background-image: url("../../assets/help-bg.png");
  background-size: 100% 280px;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 34px;
}
.help-title {
  height: 46px;
  font-size: 32px;
  font-weight: 500;
  color: #1a1d21;
  line-height: 46px;
  cursor: pointer;
}
.help-search {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.help-content {
  width: 65%;
  max-height: calc(100vh - 300px);
  background: #ffffff;
  border-radius: 8px;
  margin: 48px auto 20px;
  padding: 32px;
  overflow: hidden;
  overflow-y: auto;
}
.content-title {
  height: 26px;
  font-size: 18px;
  color: #1a1d21;
  line-height: 26px;
  margin-bottom: 24px;
}
.title-about {
  font-size: 16px;
  margin-left: 24px;
}
.search-nav {
  height: calc(100% - 50px);
  overflow: hidden;
  overflow-y: auto;
}
.search-item {
  border-bottom: 1px solid #d6dce6;
  padding-bottom: 24px;
  padding-top: 24px;
  cursor: pointer;
}
.search-item:first-child {
  padding-top: 0;
}
.search-item-title {
  min-height: 28px;
  font-size: 18px;
  font-weight: 500;
  color: #1a1d21;
  line-height: 28px;
}
.search-item-text {
  max-height: 48px;
  font-size: 16px;
  color: #535d6c;
  line-height: 24px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 12px 0;
}

.search-item-time {
  height: 28px;
  font-size: 16px;
  color: #7b89a1;
  line-height: 28px;
}
.pagination {
  width: 65%;
  margin: 10px auto 0px;
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 1300px) {
}
@media only screen and (max-width: 992px) {
  .help-nav {
    margin-top: 55px;
    background-image: url("../../assets/help-bg.png");
    background-size: 100% 180px;
    padding-top: 16px;
  }
  .help-title {
    height: 24px;
    font-size: 21px;
    line-height: 24px;
  }
  .help-search {
    margin-top: 20px;
  }
  .help-content {
    width: 94%;
    max-height: calc(100vh - 220px);
    border-radius: 4px;
    margin: 24px auto 10px;
    padding: 14px;
  }
  .content-title {
    height: 16px;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 16px;
  }
  .title-about {
    font-size: 12px;
    margin-left: 16px;
  }
  .search-nav {
    height: calc(100% - 32px);
  }
  .search-item {
    padding-bottom: 16px;
    padding-top: 16px;
  }
  .search-item-title {
    min-height: 18px;
    font-size: 14px;
    line-height: 18px;
  }
  .search-item-text {
    height: 34px;
    font-size: 12px;
    line-height: 18px;
    margin: 8px 0;
  }

  .search-item-time {
    height: 16px;
    font-size: 12px;
    line-height: 16px;
  }
  .pagination {
    width: 94%;
    margin: 8px auto 0;
  }
}
</style>
